import { useGetCobraParticipantsQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import CobraCensus from "./CobraCensus";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getAppType } from "utils/helper";

const CobraCensusModel = (): JSX.Element => {
  const { data, error, loading } = useGetCobraParticipantsQuery({
    variables: { uuid: getProspectUuid(), appType: getAppType() },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorPage />;
  }

  return <CobraCensus data={data?.prospect} />;
};
export default CobraCensusModel;
